import React from 'react'
import styled from '@emotion/styled'
import { AgGridWrapper } from 'view/components/datagrid'
import { PendingTradingRelationshipColumnDefs, pendingTradingRelationshipGridOptions } from './PendingTradingRelationshipGridModel'
import { PendingTradingRelationship } from './validateTradingRelationshipParseResult'
import { Locale, Translation } from 'locale'

interface PendingTradingEntityPanelProductProps {
  tradingRelationships: PendingTradingRelationship[]
}

const Container = styled.div`
  height: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  h4 {
    margin-bottom: 10px;
  }
`

export const PendingTradingEntityProductPanel: React.FC<PendingTradingEntityPanelProductProps> = ({ tradingRelationships }) => (
  <Container>
    <h4>{Locale.translate(Translation.TC_PENDING_TRADING_ENTITY_PRODUCTS)}</h4>
    <AgGridWrapper
      className="datagrid-borderless"
      gridOptions={pendingTradingRelationshipGridOptions}
      columnDefs={PendingTradingRelationshipColumnDefs}
      rowData={tradingRelationships}
    />
  </Container>
)
